module.exports = __webpack_public_path__ + "img/iphone-5.ce46c84e.svg";